<template lang="pug">
.bucar-territorios
    h1 {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.argentina.tituloTerritorios') }}
    el-card
        .box-card-inserir-dados-manual
            .box-card-inserir-dados-manual__conteudo
                .box-card-buscar-territorios
                    el-alert.alert-destaque(
                        type='info',
                        show-icon,
                        :closable='false',
                        effect='light'
                    )
                        template(slot='title')
                            strong {{ $t(`mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.argentina.instrucoes`) }}
                        | {{ $t(`mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.argentina.textoUnificado`) }}

                    h2.secao-titulo-territorios {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.argentina.pesquisaProdutor') }}

                    .secao-pesquisa-documento
                        el-form.form-pesquisa-documento(
                            label-position='top',
                            :model='formularioCadastroTerritorio',
                            :rules='formularioCadastroTerritorioRegras',
                            ref='formularioPesquisaDocumento'
                        )
                            .box-card-inserir-dados-manual__conteudo__bloco_pesquisa-por-territorio.width-direito
                                el-form-item(:prop='computedPropCpfCpnj')
                                    template(slot='label')
                                        span {{ $t(`mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.argentina.pesquisaDocumento`) }}
                                        el-tooltip(
                                            :content='$t(`mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.argentina.documentoProdutor`)',
                                            placement='top'
                                        )
                                            i.el-icon-info.dados-manual

                                    .input-pesquisa-por-territorio.input-car-cpf-cnpj
                                        el-select(
                                            v-model='formularioCadastroTerritorio.documentoPessoa',
                                            :loading='buscandoRepresentante',
                                            :loading-text='textoBuscandoRepresentante',
                                            filterable,
                                            remote,
                                            clearable,
                                            @clear='limparCPF',
                                            :placeholder='$t(`mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.argentina.buscaPorDocumento`)',
                                            remote-show-suffix,
                                            ref='selectCpfCnpj',
                                            :remote-method='buscarRepresentanteNomeOuCuit',
                                            :disabled='loadingResumo'
                                        )
                                            el-option(
                                                v-for='representante in representantes',
                                                :key='representante.id',
                                                :label='representante.cpfCnpj',
                                                :value='representante'
                                            )
                                                .input-pesquisa-por-representante-select
                                                    span {{ representante.nomeRazaoSocial }}
                                                    span.direita {{ `${$t('mensagens.comuns.documento')}: ${representante.cpfCnpj}` }}

                                        el-button(
                                            type='primary',
                                            icon='el-icon-search',
                                            @click.prevent='buscarTerritoriosVinculadosAr(dados.materialCodigo)',
                                            :disabled='!formularioCadastroTerritorio.documentoPessoa || !formularioCadastroTerritorio.documentoPessoa.id'
                                        ) {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.argentina.buscar') }}

                .box-card-buscar-territorios.secao-localizacao
                    h2.secao-titulo {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.argentina.pesquisaDados') }}

                    el-form.formTerritorios(
                        label-position='top',
                        :model='formBuscaTerritorios',
                        :rules='formBuscaTerritoriosRegras',
                        ref='formCadastroManualRef'
                    )
                        el-form-item(
                            :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.provincia")',
                            prop='provincia'
                        )
                            el-select#provincia(
                                v-model='formBuscaTerritorios.provincia',
                                v-loading='carregandoNivelUm',
                                :placeholder='$t("mensagens.comuns.selecione")',
                                clearable,
                                filterable,
                                @change='handleProvinciaChange',
                                @clear='handleProvinciaClear'
                            )
                                el-option(
                                    v-for='provincia in provincias',
                                    :key='provincia.id',
                                    :label='provincia.label',
                                    :value='provincia.id'
                                )

                        el-form-item(
                            :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.departamento")',
                            prop='departamento'
                        )
                            el-select#departamento(
                                v-model='formBuscaTerritorios.departamento',
                                v-loading='carregandoNivelDois',
                                :placeholder='$t("mensagens.comuns.selecione")',
                                clearable,
                                filterable,
                                :disabled='!formBuscaTerritorios.provincia',
                                @change='handleDepartamentoChange',
                                @clear='handleDepartamentoClear'
                            )
                                el-option(
                                    v-for='departamento in departamentos',
                                    :key='departamento.id',
                                    :label='departamento.label',
                                    :value='departamento.id'
                                )

                        el-form-item(
                            :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.origem")',
                            prop='localidade'
                        )
                            el-select#localidade(
                                v-model='formBuscaTerritorios.localidade',
                                v-loading='carregandoNivelTres',
                                :placeholder='$t("mensagens.comuns.selecione")',
                                clearable,
                                filterable,
                                :disabled='!formBuscaTerritorios.departamento'
                            )
                                el-option(
                                    v-for='localidade in localidades',
                                    :key='localidade.id',
                                    :label='localidade.label',
                                    :value='localidade.id'
                                )

                        el-form-item(label='Oncca')
                            el-input#oncca(
                                v-model='formBuscaTerritorios.oncca',
                                :placeholder='$t("mensagens.comuns.placeholder")',
                                maxlength='10',
                                clearable
                            )

                        el-form-item(label='Renspa')
                            el-input#renspa(
                                v-model='formBuscaTerritorios.renspa',
                                :placeholder='$t("mensagens.comuns.placeholder")',
                                maxlength='17',
                                @input='aplicarMascaraRenspa',
                                clearable
                            )

                        el-button(
                            type='primary',
                            icon='el-icon-search',
                            @click='buscarTerritorio',
                            :loading='buscandoTerritorio',
                            :disabled='!isFormValido'
                        ) {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.argentina.buscar') }}

                    .bloco-territorio-selecionado(v-if='territorioSelecionado')
                        .bloco-texto
                            strong {{ $t('mensagens.comuns.nome') }}
                            span {{ territorioSelecionado.nome || $t('mensagens.sig.erro.naoinformado') }}
                        .bloco-texto
                            strong Renspa
                            span {{ formatarRenspa(territorioSelecionado.renspa) || $t('mensagens.sig.erro.naoinformado') }}
                        .bloco-texto
                            strong {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.argentina.localidade') }}
                            span {{ territorioSelecionado.localidade || $t('mensagens.sig.erro.naoinformado') }}
                        .bloco-texto
                            strong {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.departamento') }} / {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.provincia') }}
                            span {{ getDepartamentoProvinciaTexto() }}
                        .bloco-acoes
                            el-button(
                                type='default',
                                icon='el-icon-refresh',
                                @click='limparSelecao'
                            ) {{ $t('mensagens.operacao.acoes.limparSelecao') }}

                            el-button(
                                type='primary',
                                icon='el-icon-search',
                                @click.prevent='validarTerritorioResumo',
                                :disabled='loadingResumo',
                                :loading='loadingResumo'
                            ) {{ $t('mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.analisarElegibilidade') }}

                SubEmpresaBlocoResumoElegibilidade(
                    v-if='showResumoElegibilidade',
                    :dadosAnaliseElegibilidade='dadosAnaliseElegibilidade',
                    :resultadoElegibilidade='resultadoElegibilidade',
                    :formularioCadastroTerritorio='formularioCadastroTerritorio',
                    :loadingResumo='loadingResumo',
                    :volumeDisponivelContrato='volumeDisponivelContrato',
                    :territorioSendoInserido='territorioSendoInserido',
                    :mostrarCodigoCar='mostrarCodigoCar',
                    @modal-analise-elegibilidade='modalAnaliseElegibilidade',
                    @validar-territorio-manual='validarTerritorioManual',
                    @volume-formatado='volumeRecebidoFormatado'
                )
</template>

<script>
import SubEmpresaBlocoResumoElegibilidade from './SubEmpresaBlocoResumoElegibilidade.vue';
import ContratoOriginacaoServiceSubEmpresa from '@/services/ContratoOriginacaoServiceSubEmpresa';
import TerritorioService from '@/services/TerritorioService';
import LocalidadeService from '@/services/LocalidadeService';
import RepresentanteService from '@/services/RepresentanteService';
import formatters from '@/utils/formatters';
import validators from '@/utils/validators';
import { mascaraCuit } from '@/utils/masks/cuit.js';
import { mapGetters } from 'vuex';

export default {
    name: 'CardBuscarTerritorios',
    components: {
        SubEmpresaBlocoResumoElegibilidade,
        validators
    },

    props: {
        volumeDisponivelContrato: {
            type: Number,
            required: true
        },
        dados: {
            type: Object,
            required: true
        },
        numeroContrato: {
            type: String,
            required: true
        },
        isRastreabilidadeOffline: {
            type: Boolean,
            required: true
        },
        idSucursal: {
            type: Number,
            required: false,
            default: 0
        }
    },

    mounted() {
        this.listarLocalidadeNivelUm();
    },

    data() {
        const validarRuc = (rule, value, callback) => {
            if (!value || !value.id) {
                callback(new Error(this.$t('mensagens.pessoas.cuitErro')));
                return;
            }
            callback();
        };

        const validarRenspa = (rule, value, callback) => {
            if (value === '') {
                callback(
                    new Error(
                        this.$t(
                            'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.campoObrigatorio'
                        )
                    )
                );
                return;
            }
            callback();
        };

        return {
            // Formulários
            formBuscaTerritorios: {
                provincia: null,
                departamento: null,
                localidade: null,
                oncca: null,
                renspa: null
            },
            formBuscaTerritoriosRegras: {
                provincia: [
                    {
                        required: true,
                        message: this.$t('mensagens.comuns.campoObrigatorio'),
                        trigger: 'change'
                    }
                ]
            },
            formularioCadastroTerritorio: {
                volumeTerritorio: '',
                territorioSelecionado: '',
                territorioSelecionadoDocumento: '',
                idTerritorio: '',
                documentoPessoa: {}
            },
            formularioCadastroTerritorioRegras: {
                documentoPessoa: [
                    {
                        required: true,
                        validator: validarRuc,
                        trigger: 'change'
                    }
                ],
                territorioSelecionadoDocumento: [
                    {
                        required: true,
                        validator: validarRenspa,
                        trigger: 'change'
                    }
                ]
            },

            // Estados de carregamento
            carregandoNivelUm: false,
            carregandoNivelDois: false,
            carregandoNivelTres: false,
            buscandoTerritorio: false,
            loadingResumo: false,
            territorioSendoInserido: false,
            buscandoRepresentante: false,

            // Dados das localidades
            provincias: [],
            departamentos: [],
            localidades: [],

            // Dados dos representantes
            representantes: [],
            territoriosVinculados: [],
            textoBuscandoRepresentante: '',
            inputValueRepresentante: '',

            // Território selecionado
            territorioSelecionado: null,
            buscaRealizada: false,
            tipoSelecao: '', // 'documento' ou 'localizacao'
            idDadosContratoOriginacaoEdicao: null,

            // Dados de elegibilidade
            resultadoElegibilidade: 'INDEFINIDO',
            dadosAnaliseElegibilidade: this.getInitialDadosAnalise(),
            showResumoElegibilidade: false
        };
    },

    watch: {
        'formBuscaTerritorios.provincia'(newVal) {
            if (newVal) {
                this.handleProvinciaChange();
            }
        },
        'formBuscaTerritorios.departamento'(newVal) {
            if (newVal) {
                this.handleDepartamentoChange();
            }
        },
        'formularioCadastroTerritorio.territorioSelecionadoDocumento':
            function (newVal) {
                if (newVal) {
                    this.limparDadosResumo();
                }
            },
        'formularioCadastroTerritorio.documentoPessoa': function (newVal) {
            if (newVal) {
                this.limparDadosResumo();
                this.territoriosVinculados = [];
                this.formularioCadastroTerritorio.territorioSelecionadoDocumento =
                    '';
            }
        }
    },

    computed: {
        ...mapGetters(['usuarioLogado']),

        computedPropCpfCpnj() {
            return !this.isRastreabilidadeOffline ? 'documentoPessoa' : '';
        },

        isFormValido() {
            const { provincia } = this.formBuscaTerritorios;
            return provincia;
        },

        isButtonEnabledDocumento() {
            return (
                this.formularioCadastroTerritorio.documentoPessoa &&
                Object.keys(this.formularioCadastroTerritorio.documentoPessoa)
                    .length > 0 &&
                this.formularioCadastroTerritorio
                    .territorioSelecionadoDocumento !== ''
            );
        },

        mostrarCodigoCar() {
            return this.tipoSelecao !== 'documento';
        }
    },

    methods: {
        // Inicializar dados de análise
        getInitialDadosAnalise() {
            return {
                elegibilidade: '',
                valor: '',
                cpfCnpj: '',
                safraNome: '',
                dadosDiagnostico: {
                    diagnosticoRepresentante: [],
                    diagnosticoCar: null,
                    resultadoDiagnosticoRastreabilidade: null,
                    nivelAlertaRastreabilidade: null
                },
                saldoTerritorial: {
                    areaHa: null,
                    anoSafra: null,
                    capacidadeProdutiva: null,
                    cultura: null,
                    rendimento: null,
                    renspa: null,
                    saldoCapacidadeProdutiva: null,
                    saldoConsumidoCapacidadeProdutiva: null
                },
                dadosCalculoRaio: {
                    distanciaRaioMunicipioECar: null,
                    possuiIntersecao: null,
                    siglaEstadoContrato: null,
                    distanciaRaioLocalidade: null,
                    distanciaPermitida: null
                },
                dadosRestricaoEstado: {
                    possuiRestricaoEstado: null,
                    siglaEstadoCar: null,
                    siglaEstadoPermitido: null
                },
                dadosBuscaSaldo: {
                    id: null,
                    codigoCar: '',
                    capacidadeProdutiva: null,
                    saldoCARcapacidadeProdutiva: null,
                    calculoSaca: {
                        saldoCARcapacidadeProdutivaSaca: null,
                        saldoCarComprometido: null
                    },
                    cultura: {
                        id: null,
                        nome: '',
                        codigo: ''
                    },
                    anoSafra: {
                        id: null,
                        ano: null,
                        tipoSafra: '',
                        descricao: ''
                    },
                    criadoEm: null,
                    saldoCarComprometido: null
                },
                territorioOutput: {
                    finca: null,
                    padron: null,
                    geom: null,
                    idTerritorio: null,
                    nomeTerritorio: null
                }
            };
        },

        // === MÉTODOS DE PESQUISA POR DOCUMENTO ===
        async buscarRepresentanteNomeOuCuit(filtro) {
            this.buscandoRepresentante = true;

            try {
                if (!this.isValidSearchFilter(filtro)) {
                    this.handleInvalidFilter();
                    return;
                }

                this.setSearchingMessage();
                const filtroSanitizado = this.sanitizeFilter(filtro);
                const representantes = await this.fetchRepresentantes(filtroSanitizado);
                
                this.processSearchResults(representantes, filtroSanitizado);
            } catch (error) {
                this.handleSearchError(error);
            } finally {
                this.buscandoRepresentante = false;
            }
        },

        isValidSearchFilter(filtro) {
            const MIN_LENGTH = 3;
            return filtro && filtro.length >= MIN_LENGTH;
        },

        handleInvalidFilter() {
            this.textoBuscandoRepresentante = this.$t(
                'mensagens.comuns.digiteNoMinimo3CaracteresParaPesquisar'
            );
            this.inputValueRepresentante = '';
        },

        setSearchingMessage() {
            this.textoBuscandoRepresentante = this.$t(
                'mensagens.sistema.buscandoInformacoes'
            );
        },

        sanitizeFilter(filtro) {
            return filtro.replace(/[^\w\s]/gi, '');
        },

        async fetchRepresentantes(filtroSanitizado) {
            const isSucursal = this.$route.query.view;
            
            const serviceCall = isSucursal
                ? RepresentanteService.buscarPorNomeOuCuitSucursal(
                      filtroSanitizado,
                      this.numeroContrato,
                      this.idSucursal
                  )
                : RepresentanteService.buscarPorNomeOuCuit(filtroSanitizado);

            const { data } = await serviceCall;
            return data;
        },

        processSearchResults(representantes, filtroSanitizado) {
            this.representantes = representantes.map(item => ({
                ...item,
                cpfCnpj: mascaraCuit(item.cpfCnpj)
            }));
            this.inputValueRepresentante = filtroSanitizado;
        },

        handleSearchError() {
            this.textoBuscandoRepresentante = this.$t(
                'mensagens.sistema.erroAoBuscarInformacoes'
            );
        },

        async buscarTerritoriosVinculadosAr(cultura) {

            if (!this.isDocumentoPessoaValido()) {
                this.exibirMensagemDocumentoObrigatorio();
                return;
            }

            const parametros = this.construirParametrosRequisicao();
            
            try {
                const territorios = await this.executarBuscaTerritorios(parametros);
                this.processarResultadoBusca(territorios, cultura);
            } catch (error) {
                this.tratarErroRequisicao(error);
            }
        },

        processarResultadoBusca(territorios, cultura) {
            if (this.possuiTerritorios(territorios)) {
                this.configurarTerritoriosEncontrados(territorios, cultura);
            } else {
                this.alertRepresentanteSemTerritorios();
            }
        },

        isDocumentoPessoaValido() {
            return this.formularioCadastroTerritorio.documentoPessoa?.id;
        },

        exibirMensagemDocumentoObrigatorio() {
            this.$notify.warning({
                message: this.$t(
                    'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.argentina.pesquisaPorDocumento'
                )
            });
        },

        construirParametrosRequisicao() {
            return {
                idRepresentante: this.formularioCadastroTerritorio.documentoPessoa.id,
                numeroContrato: this.numeroContrato,
                idSucursal: this.idSucursal
            };
        },

        async executarBuscaTerritorios(parametros) {
            const service = this.determinarServicoTerritorio();
            const { data } = await service(parametros);
            return data.itens || [];
        },

        determinarServicoTerritorio() {
            const isSucursal = this.$route.query.view;
            return isSucursal
                ? TerritorioService.buscarTerritoriosVinculadosPessoaSucursal
                : TerritorioService.buscarTerritoriosVinculadosPessoaAR;
        },

        configurarTerritoriosEncontrados(territorios, cultura) {
            this.territoriosVinculados = territorios;
            this.$emit('modal-territorios', territorios, cultura);
            this.tipoSelecao = 'documento';
        },
        possuiTerritorios(territorios) {
            return territorios && territorios.length > 0;
        },

        tratarErroRequisicao() {
            this.$notify.error({
                message: this.$t(
                    'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.erroRequisicao'
                )
            });
        },

        formatarRenspa(renspa) {
            if (!renspa) return '-';
            if (renspa.length !== 13) return renspa;
            return `${renspa.slice(0, 2)}.${renspa.slice(2, 5)}.${renspa.slice(
                5,
                6
            )}.${renspa.slice(6, 11)}/${renspa.slice(11)}`;
        },

        definirTerritorioSelecionado(territorio) {
            if (!territorio) return;

            this.territorioSelecionado = territorio;
            this.formularioCadastroTerritorio.territorioSelecionadoDocumento =
                territorio.renspa || '';
            this.formularioCadastroTerritorio.idTerritorio =
                territorio.id || '';

            this.limparDadosResumo();

            this.$nextTick(() => {
                if (this.$refs.selectTerritorioDocumento) {
                    this.$refs.selectTerritorioDocumento.focus();
                }
            });
        },

        preencherParaEdicao(row) {
            if (!row) return;

            this.tipoSelecao = 'localizacao';
            this.idDadosContratoOriginacaoEdicao = row.id || null;
            this.territorioSelecionado = {
                id: row.idTerritorio,
                idRepresentante: row.idRepresentante || null,
                nome: row.territorioNome || '',
                renspa: row.renspaTerritorio || ''
            };
            this.formularioCadastroTerritorio.idTerritorio = row.idTerritorio;
            this.formularioCadastroTerritorio.territorioSelecionadoDocumento = row.renspaTerritorio || '';
            this.formularioCadastroTerritorio.volumeTerritorio = row.volumeInformado || (row.volume != null ? String(row.volume) : '');
            this.limparDadosResumo();
        },

        limparCPF() {
            this.formularioCadastroTerritorio.documentoPessoa = '';
            this.territoriosVinculados = [];
            this.limparDadosResumo();
        },

        validarTerritorioResumoDocumento() {
            this.$refs['formularioPesquisaDocumento'].validate(valid => {
                if (valid) {
                    this.tipoSelecao = 'documento';
                    this.realizarResumo();
                } else {
                    return false;
                }
            });
        },

        alertRepresentanteSemTerritorios() {
            this.$messageBox.alert(
                this.$t(
                    'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.argentina.sistemaNaoIndentificou'
                ),
                this.$t(
                    'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.aviso'
                ),
                {
                    confirmButtonText: 'Ok',
                    type: 'info',
                    customClass: 'message-box-infor-sub-empresa-manual'
                }
            );
        },

        // === MÉTODOS DE BUSCA POR LOCALIZAÇÃO ===
        handleProvinciaChange() {
            if (this.formBuscaTerritorios.provincia) {
                this.listarLocalidadeNivelDois(
                    this.formBuscaTerritorios.provincia
                );
                this.resetFieldIfNotEmpty('departamento');
                this.resetFieldIfNotEmpty('localidade');
                this.limparSelecao();
            }
        },

        handleProvinciaClear() {
            this.resetFieldIfNotEmpty('departamento');
            this.resetFieldIfNotEmpty('localidade');
            this.limparSelecao();
        },

        handleDepartamentoClear() {
            this.resetFieldIfNotEmpty('localidade');
            this.limparSelecao();
        },

        handleDepartamentoChange() {
            if (this.formBuscaTerritorios.departamento) {
                this.listarLocalidadeNivelTres(
                    this.formBuscaTerritorios.departamento
                );
                this.resetFieldIfNotEmpty('localidade');
                this.limparSelecao();
            }
        },

        resetFieldIfNotEmpty(field) {
            if (this.formBuscaTerritorios[field]) {
                this.formBuscaTerritorios[field] = '';
            }
        },

        async buscarTerritorio() {
            this.buscandoTerritorio = true;
            this.buscaRealizada = false;
            this.territorioSelecionado = null;

            try {
                const validacao = await this.validarFormulario();
                if (!validacao) return;

                const parametrosBusca = this.prepararParametrosBusca();
                const resultado = await this.realizarBuscaAPI(parametrosBusca);

                if (resultado && resultado.length > 0) {
                    this.territoriosVinculados = resultado;
                    this.$emit('modal-territorios', resultado);
                    this.tipoSelecao = 'localizacao';
                } else {
                    this.$messageBox.alert(
                        this.$t(
                            'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.argentina.sistemaNaoIndentificouTerritorio'
                        ),
                        this.$t(
                            'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.aviso'
                        ),
                        {
                            confirmButtonText: 'Ok',
                            type: 'info',
                            customClass: 'message-box-infor-sub-empresa-manual'
                        }
                    );
                }
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.erroRequisicao'
                    )
                });
            } finally {
                this.buscandoTerritorio = false;
                this.buscaRealizada = true;
            }
        },

        async validarFormulario() {
            return new Promise(resolve => {
                this.$refs['formCadastroManualRef'].validate(valid => {
                    if (!valid) {
                        this.$notify.error({
                            message: this.$t(
                                'mensagens.territorio.preenchaCamposObrigatorios'
                            ),
                            duration: 3000
                        });
                    }
                    resolve(valid);
                });
            });
        },

        prepararParametrosBusca() {
            const { provincia, departamento, localidade, oncca, renspa } =
                this.formBuscaTerritorios;

            return {
                provincia: provincia || null,
                departamento: departamento || null,
                localidade: localidade || null,
                oncca: oncca || null,
                renspa: renspa ? renspa.replace(/\D/g, '') : null,
                numeroContrato: this.numeroContrato || null
            };
        },

        async realizarBuscaAPI(parametros) {
            try {
                const isSucursal = this.$route.query.view;
                const service = isSucursal
                    ? TerritorioService.buscarTerritoriosSucursal
                    : TerritorioService.buscarTerritoriosRevenda;

                const { data } = await service(parametros);

                return Array.isArray(data?.itens) ? data.itens : [];
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.erroRequisicao'
                    )
                });
                return [];
            }
        },

        getDepartamentoProvinciaTexto() {
            if (this.territorioSelecionado) {
                const { departamento, provincia } = this.territorioSelecionado;
                if (departamento && provincia) {
                    return `${departamento} / ${provincia}`;
                }
                return (
                    this.territorioSelecionado.departamentoProvincia ||
                    this.$t('mensagens.sig.erro.naoinformado')
                );
            }
            return this.$t('mensagens.sig.erro.naoinformado');
        },

        limparSelecao() {
            this.territorioSelecionado = null;
            this.buscaRealizada = false;
            this.formularioCadastroTerritorio.idTerritorio = '';
            this.tipoSelecao = '';
            this.limparDadosResumo();
        },

        aplicarMascaraRenspa(valor) {
            if (!valor) return;

            // Remove todos os caracteres não numéricos
            let apenasNumeros = valor.replace(/\D/g, '');
            // Limita a 13 dígitos
            apenasNumeros = apenasNumeros.substring(0, 13);

            let valorFormatado = apenasNumeros;

            // Aplica a formatação baseada no comprimento, usando else if para evitar sobreposição
            if (apenasNumeros.length >= 12) {
                // Formato completo: XX.XXX.X.XXXXX/XX
                valorFormatado = apenasNumeros.replace(
                    /^(\d{2})(\d{3})(\d{1})(\d{5})(\d{0,2})/,
                    '$1.$2.$3.$4/$5'
                );
            } else if (apenasNumeros.length >= 7) {
                // Formato parcial: XX.XXX.X.XXXXX
                valorFormatado = apenasNumeros.replace(
                    /^(\d{2})(\d{3})(\d{1})(\d+)/,
                    '$1.$2.$3.$4'
                );
            } else if (apenasNumeros.length >= 6) {
                // Formato parcial: XX.XXX.X
                valorFormatado = apenasNumeros.replace(
                    /^(\d{2})(\d{3})(\d+)/,
                    '$1.$2.$3'
                );
            } else if (apenasNumeros.length >= 3) {
                // Formato parcial: XX.XXX
                valorFormatado = apenasNumeros.replace(
                    /^(\d{2})(\d+)/,
                    '$1.$2'
                );
            }

            this.formBuscaTerritorios.renspa = valorFormatado;
        },

        // === MÉTODOS COMUNS ===
        validarTerritorioResumo() {
            if (this.territorioSelecionado) {
                this.realizarResumo();
            }
        },

        async realizarResumo() {
            try {
                this.limparDadosResumo();
                const isSucursal = this.$route.query.view;

                const dados = {
                    idRepresentante:
                        this.tipoSelecao === 'documento'
                            ? this.formularioCadastroTerritorio.documentoPessoa
                                  .id
                            : this.territorioSelecionado.idRepresentante,
                    idTerritorio:
                        this.tipoSelecao === 'documento'
                            ? this.formularioCadastroTerritorio.idTerritorio
                            : this.territorioSelecionado.id,
                    numeroContrato: this.numeroContrato,
                    isSucursal: !!isSucursal,
                    idDadosContratoOriginacao: this.idDadosContratoOriginacaoEdicao || 0,
                    idSucursal: this.idSucursal
                };

                this.showResumoElegibilidade = true;
                this.loadingResumo = true;

                const resumo =
                    await ContratoOriginacaoServiceSubEmpresa.buscarResumoAnaliseElegibilidadePreInsercaoTerritorioAr(
                        dados
                    );

                this.resultadoElegibilidade = resumo.data.resultadoResumoAnaliseElegibilidadePreInsercaoTerritorioSubempresa;
                this.dadosAnaliseElegibilidade.dadosDiagnostico = resumo.data.diagnosticoSocioambiental;
                this.dadosAnaliseElegibilidade.dadosCalculoRaio = resumo.data.raioTerritorio;
                this.dadosAnaliseElegibilidade.elegibilidade = this.resultadoElegibilidade;
                this.dadosAnaliseElegibilidade.saldoTerritorial = resumo.data.diagnosticoSaldoTerritorial;
                this.dadosAnaliseElegibilidade.territorioOutput = resumo.data.territorioOutput;
                this.dadosAnaliseElegibilidade.certificacao = resumo.data.certificacao;
            } catch (e) {
                this.showResumoElegibilidade = false;

                if (
                    e.response?.data?.message ===
                    'rendimento.provinciaEDepartamentoNaoEncontrado'
                ) {
                    this.$notify.error({
                        message: this.$t(
                            'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.argentina.erroRendimento'
                        )
                    });
                    return;
                }

                this.$notify.error({
                    message: e.response?.data?.message
                });
                this.limparDadosResumo();
            } finally {
                this.loadingResumo = false;
            }
        },

        validarTerritorioManual() {
            // Validar volume
            if (!this.formularioCadastroTerritorio.volumeTerritorio) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.subEmpresaGestao.inserirdadoscontratooriginacaomanual.argentina.erroVolume'
                    ),
                    duration: 2000
                });
                return;
            }

            // Validar se foi feita por documento
            if (this.tipoSelecao === 'documento') {
                let temErroForm = false;
                this.$refs['formularioPesquisaDocumento'].validate(valid => {
                    if (!valid) {
                        temErroForm = true;
                    }
                });
                if (!temErroForm) {
                    this.adicionarTerritorioListagem();
                }
            } else {
                this.adicionarTerritorioListagem();
            }
        },

        async adicionarTerritorioListagem() {
            this.territorioSendoInserido = true;

            try {
                const dadosContrato = {
                    idTerritorio:
                        this.formularioCadastroTerritorio.idTerritorio,
                    numeroContrato: this.numeroContrato,
                    isSucursal: !!this.$route.query.view,
                    volume: parseFloat(
                        this.formularioCadastroTerritorio.volumeTerritorio.replace(
                            ',',
                            '.'
                        )
                    ),
                    idSucursal: this.idSucursal
                };

                // Adicionar dados do representante apenas se for busca por documento
                if (
                    this.tipoSelecao === 'documento' &&
                    this.formularioCadastroTerritorio.documentoPessoa?.id
                ) {
                    dadosContrato.documentoRepresentante =
                        this.formularioCadastroTerritorio.documentoPessoa.cpfCnpj;
                    dadosContrato.idRepresentante =
                        this.formularioCadastroTerritorio.documentoPessoa.id;
                } else {
                    dadosContrato.documentoRepresentante = null;
                    dadosContrato.idRepresentante = null;
                }

                const response =
                    await ContratoOriginacaoServiceSubEmpresa.inserirDadosContratoAR(
                        dadosContrato
                    );

                this.$notify.success({
                    message: response.data.mensagemCadastroSucesso
                });

                this.$emit('territorio-inserido');
                this.resetFormularioCompleto();
            } catch (error) {
                this.exibirNotificacoesErros(error);
            } finally {
                this.territorioSendoInserido = false;
            }
        },

        exibirNotificacoesErros(error) {
            if (!error.response) {
                this.$notify.error({
                    message: 'Erro de conexão. Tente novamente.'
                });
                return;
            }

            const { data } = error.response;

            if (data.type === 'MEDIA_CAPACIDADE_REGIONAL') {
                this.$emit('mostrar-modal-capacidade', data.output);
            } else if (data.type === 'FORA_DO_RAIO_PERMITIDO') {
                this.$messageBox.alert(data.message, data.title, {
                    confirmButtonText: 'Voltar',
                    type: 'warning'
                });
            } else {
                this.$notify.error({
                    message: data.message || 'Erro ao inserir território'
                });
            }
        },

        resetFormularioCompleto() {
            this.formBuscaTerritorios = {
                provincia: '',
                departamento: '',
                localidade: '',
                oncca: '',
                renspa: ''
            };
            this.formularioCadastroTerritorio = {
                volumeTerritorio: '',
                territorioSelecionado: '',
                territorioSelecionadoDocumento: '',
                idTerritorio: '',
                documentoPessoa: ''
            };
            this.idDadosContratoOriginacaoEdicao = null;

            this.$nextTick(() => {
                if (this.$refs.formCadastroManualRef) {
                    this.$refs.formCadastroManualRef.clearValidate();
                }
                if (this.$refs.formularioPesquisaDocumento) {
                    this.$refs.formularioPesquisaDocumento.clearValidate();
                }
            });

            this.representantes = [];
            this.territoriosVinculados = [];
            this.limparSelecao();
            this.departamentos = [];
            this.localidades = [];
            this.tipoSelecao = '';
        },

        volumeRecebidoFormatado() {
            this.formularioCadastroTerritorio.volumeTerritorio =
                formatters.formatarTonelada(
                    this.formularioCadastroTerritorio.volumeTerritorio
                );
        },

        modalAnaliseElegibilidade() {
            if (this.loadingResumo) return;

            this.dadosAnaliseElegibilidade.safraNome = this.dados.safraNome;
            this.$emit('emitir-elegibilidade', this.dadosAnaliseElegibilidade);
        },

        limparDadosResumo() {
            this.showResumoElegibilidade = false;
            this.dadosAnaliseElegibilidade = this.getInitialDadosAnalise();
            this.resultadoElegibilidade = 'INDEFINIDO';
        },

        // === MÉTODOS DE LOCALIDADES ===
        orderName(a, b) {
            const nameA = a.label.toUpperCase();
            const nameB = b.label.toUpperCase();
            if (nameA < nameB) return -1;
            if (nameA > nameB) return 1;
            return 0;
        },

        async listarLocalidadeNivelUm() {
            try {
                this.carregandoNivelUm = true;
                const { data } =
                    await LocalidadeService.buscarLocalidadeNivelUm();

                const dataFormat = data
                    .map(item => ({ label: item.nome, id: item.id }))
                    .sort((a, b) => this.orderName(a, b));

                this.provincias = dataFormat;
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.pessoas.erroBuscarLocalidadeNivelUm'
                    )
                });
            } finally {
                this.carregandoNivelUm = false;
            }
        },

        async listarLocalidadeNivelDois(id) {
            try {
                this.carregandoNivelDois = true;
                const { data } =
                    await LocalidadeService.buscarLocalidadeNivelDois(id);

                const dataFormat = data
                    .map(item => ({ label: item.nome, id: item.id }))
                    .sort((a, b) => this.orderName(a, b));

                this.departamentos = dataFormat;
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.pessoas.erroBuscarLocalidadeNivelDois'
                    )
                });
            } finally {
                this.carregandoNivelDois = false;
            }
        },

        async listarLocalidadeNivelTres(id) {
            try {
                this.carregandoNivelTres = true;
                const { data } =
                    await LocalidadeService.buscarLocalidadeNivelTres(id);

                this.localidades = [];
                if (data) {
                    const dataFormat = data
                        .map(item => ({ label: item.nome, id: item.id }))
                        .sort((a, b) => this.orderName(a, b));

                    this.localidades = dataFormat;
                }
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.pessoas.erroBuscarLocalidadeNivelDois'
                    )
                });
            } finally {
                this.carregandoNivelTres = false;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.bucar-territorios {
    padding-top: 20px;
    width: 100%;

    h1 {
        font-weight: bold;
        font-size: 16px;
        margin-bottom: 10px;
    }

    .el-card {
        margin-top: 10px;
        display: flex;

        :deep(.el-card__body) {
            width: 100%;
        }
    }

    .box-card-inserir-dados-manual__conteudo {
        display: flex;
        flex-direction: column;
        align-content: space-around;
        justify-content: space-between;
        gap: 10px;

        .el-alert {
            :deep(el-alert__description) {
                font-size: 14px !important;
            }
        }

        .secao-titulo {
            font-weight: bold;
            font-size: 16px;
            padding: 8px 0px;
            color: var(--primary-font-color);
        }
        .secao-titulo-territorios {
            font-weight: bold;
            font-size: 16px;
            color: var(--primary-font-color);
            margin-top: 30px;
        }

        .secao-pesquisa-documento {
            margin-top: 5px;
            .form-pesquisa-documento {
                .box-card-inserir-dados-manual__conteudo__bloco_pesquisa-por-territorio {
                    display: flex;
                    flex-direction: column;
                    margin-bottom: 15px;

                    &.width-direito {
                        width: 100% !important;
                        border-bottom: 1px solid #e0e0e0;
                        padding-bottom: 15px;
                        margin-bottom: 0px;
                    }

                    .input-pesquisa-por-territorio {
                        display: flex;

                        .el-select {
                            width: 100%;
                        }

                        .el-button {
                            height: 40px;
                            border-radius: 0px 4px 4px 0px;
                            padding: 12px 35px;
                        }
                    }
                }

                .box-card-inserir-dados-manual__conteudo__bloco__buttons {
                    display: flex;
                    justify-content: flex-end;
                    gap: 15px;
                    margin-top: 15px;

                    button.el-button.el-button--primary {
                        width: 100%;
                        height: 40px;
                    }
                }
            }
        }

        .secao-localizacao {
            .formTerritorios {
                display: grid;
                grid-template-columns: repeat(3, 1fr);
                gap: 10px 20px;
                margin-bottom: 17px;

                .el-select {
                    width: 100%;
                }

                button {
                    height: 40px;
                    margin-top: auto;
                    margin-bottom: 9px;
                }
            }

            .bloco-territorio-selecionado {
                display: grid;
                grid-template-columns: repeat(4, 1fr) 2fr;
                gap: 20px;
                padding: 20px;
                background-color: #f8f9fa;
                border-radius: 8px;
                border: 1px solid #e0e0e0;
                margin-top: 20px;

                .bloco-texto {
                    display: flex;
                    flex-direction: column;
                    gap: 5px;

                    strong {
                        font-weight: bold;
                        color: var(--primary);
                        font-size: 14px;
                    }

                    span {
                        font-size: 13px;
                        color: #666;
                    }
                }

                .bloco-acoes {
                    display: grid;
                    grid-template-columns: 1fr 1fr;
                    align-items: end;
                    gap: 10px;

                    button {
                        width: 100%;
                        height: 36px;
                        margin-left: 0 !important;
                    }
                }
            }
        }
    }

    .input-car-cpf-cnpj {
        :deep(.el-input__inner) {
            border-radius: 4px 0px 0px 4px !important;
        }
    }

    i.el-tooltip.el-icon-info.dados-manual {
        margin-left: 4px;
    }

    .input-pesquisa-por-representante-select {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .direita {
            font-size: 12px;
            color: #666;
        }
    }
}
</style>
